import React, { useState } from 'react';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { useMutation } from 'urql';
import gql from 'graphql-tag';
import { useAnalytics } from '../../../utils/analytics-provider/analytics-provider';
import {
  ArticleHelpfulWrapper,
  HeaderThree,
  ThanksForFeedback,
  GreenCheckOutlined,
  FeedbackWrapper,
  FeedbackTextArea,
  FeedbackSubmitButton,
  ArticleHelpfulButtons,
  FeedbackContactUsWrapper,
  ContactFlowWrapper,
  FeedbackSubmitWrapper
} from './article-helpful.styles';
import { useArticleContext } from '../context';
import { ContactFlowModule } from '../../home/contact-flow';

const ArticleHelpful = () => {
  const { strapiArticle } = useArticleContext() || {};
  const [feedbackResult, setFeedbackResult] = useMutation(gql`
    mutation SetArticleFeedback($articleId: ID!, $wasUseful: Boolean!, $feedback: String) {
      setArticleFeedback(
        articleId: $articleId
        input: { wasUseful: $wasUseful, feedback: $feedback }
      ) {
        status {
          type
          message
        }
      }
    }
  `);
  const [isHelpful, setIsHelpful] = useState(undefined);
  const [wasNoSelected, setWasNoSelected] = useState(false);
  const [feedback, setFeedback] = useState();
  const { trackEvent } = useAnalytics();

  const ProvideFeedback = (wasHelpful) => {
    setIsHelpful(wasHelpful);
    setWasNoSelected(true);
  };

  const SendFeedback = async (isHelpful) => {
    trackEvent('article_feedback', {
      articleId: strapiArticle?.uid,
      wasUseful: isHelpful,
      feedback
    });

    await setFeedbackResult({
      articleId: strapiArticle?.uid,
      wasUseful: isHelpful,
      feedback
    }).catch((error) => {
      console.error('failed to provide feedback', error);
    });

    setIsHelpful(true);
  };

  const hasEnteredFeedback = feedback?.length > 0;
  return (
    <ArticleHelpfulWrapper>
      <HeaderThree>Was this article helpful?</HeaderThree>

      {isHelpful === true && (
        <ThanksForFeedback>
          <GreenCheckOutlined /> Thanks for the feedback.
        </ThanksForFeedback>
      )}

      {isHelpful === false && (
        <FeedbackContactUsWrapper>
          <FeedbackWrapper>
            We're sorry to hear that. Please let us know how we can improve the article.
            <FeedbackTextArea
              onChange={(event) => setFeedback(event.target.value)}
              placeholder="ENTER FEEDBACK HERE..."
            />
            Your feedback will help improve this article only. Please chat or contact us if you have
            any questions.
            <FeedbackSubmitWrapper>
              <FeedbackSubmitButton
                disabled={feedbackResult?.fetching || !feedback || !hasEnteredFeedback}
                onClick={() => SendFeedback(false)}
              >
                SUBMIT
              </FeedbackSubmitButton>
            </FeedbackSubmitWrapper>
          </FeedbackWrapper>
        </FeedbackContactUsWrapper>
      )}

      {wasNoSelected && (
        <ContactFlowWrapper>
          <ContactFlowModule />
        </ContactFlowWrapper>
      )}

      {isHelpful === undefined && (
        <ArticleHelpfulButtons>
          <SecondaryButton onClick={() => SendFeedback(true)}>YES</SecondaryButton>

          <SecondaryButton onClick={() => ProvideFeedback(false)}>NO</SecondaryButton>
        </ArticleHelpfulButtons>
      )}
    </ArticleHelpfulWrapper>
  );
};

export default ArticleHelpful;
